export const required = {
  required: true,
  message: 'This field is required'
}

export const email = {
  type: 'email' as 'email',
  message: 'Invalid email address'
}
